import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { CashOutFormatter } from "../../../utils/formatters/CashOutFormatter";
import { images } from "../../../../config/paths";
import { css } from "./csspdf";



export const PDF = ({ masterArray, detalleRegistro, ordenesArray, ventasArray, anticiposArray, descuentosArray }) => {

    let master = [...masterArray];
    let id = master[0]?.id;
    let periodo = master[0]?.period_register;
    let hoursPeriodo = master[0]?.hours_register;
    let dateRegister = master[0]?.date_register;
    let hourRegister = master[0]?.hour_register;
    let userName = master[0]?.userName;
    let fondo = master[0]?.cash_base;
    let esperado = master[0]?.expected_total;
    let real = master[0]?.real_total;
    let difference = master[0]?.difference;

    let detalle = [...detalleRegistro];

    let ordenes = [...ordenesArray];

    let ordenesFormatter = CashOutFormatter(ordenes);

    let ventas = [...ventasArray];
    let ventasFormatter = CashOutFormatter(ventas);

    let anticipos = [...anticiposArray];
    let anticiposFormatter = CashOutFormatter(anticipos);

    let descuentos = [...descuentosArray];



    return (
        <Document title={`Corte: ${id} (${periodo})`} author='HDL Technology' producer='HDL Technology' pdfVersion='1.0'>
            <Page size="LETTER" orientation='portrait' style={[]}>
                {/* Header */}
                <View style={css.row}>
                    <View style={[css.px_4, { marginTop: 20 }]}>
                        <Image src={images.logo} style={css.logo} />
                    </View>
                    <View style={[css.px_3, { marginTop: 20 }]}>
                        <Text style={[css.h1, css.fw_bold]}>HARDWARE DIAGNOSTIC LAB OF TECHNOLOGY</Text>
                        <Text style={[css.h6, css.px_4]}>Corte de caja (Periodo: {periodo}, {hoursPeriodo}).</Text>
                    </View>
                    <View style={[css.px_3, { marginTop: 20 }]}>
                        <Text style={[css.tText]}>Dia:    {dateRegister}</Text>
                        <Text style={[css.tText]}>Hora: {hourRegister} hrs.</Text>
                        <Text style={[css.tText]}>Cap.   {userName}</Text>
                    </View>
                </View>

                {/* Sumario */}
                <View style={[css.row, { marginTop: 20 }]}>
                    {/* Ventas */}
                    <View style={[css.px_4, css.text_center]}>
                        <Text style={[css.px_4, css.py_1, css.h6, css.fwBold]}>VENTAS</Text>
                        <View style={css.line} />
                        {detalle.map((item, index) => (
                            <View style={[css.row, css.space_between]} key={index}>
                                <Text style={[css.h6]}>{item.CODE}:</Text>
                                <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.expected_amount)}</Text>
                            </View>
                        ))}
                        <View style={[css.line, { marginVertical: 4 }]} />
                        <View style={[css.row, css.space_between]}>
                            <Text style={[css.h6, css.fwBold]}>Total:</Text>
                            <Text style={[css.h6, css.fwBold, css.px_5]}>
                                {Intl.NumberFormat('es-MX', {
                                    style: 'currency',
                                    currency: 'MXN'
                                }).format(
                                    detalle.reduce((acc, item) => acc + (Number(item.expected_amount) || 0), 0)
                                )}
                            </Text>
                        </View>
                    </View>
                    {/* Declarado */}
                    <View style={[css.px_5, css.text_center]}>
                        <Text style={[css.px_5, css.py_1, css.h6, css.fwBold]}>DECLARADO</Text>
                        <View style={css.line} />
                        {detalle.map((item, index) => (
                            <View style={[css.row, css.space_between]} key={index}>
                                <Text style={[css.h6]}>{item.CODE}:</Text>
                                <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.declared_amount)}</Text>
                            </View>
                        ))}
                        <View style={[css.line, { marginVertical: 4 }]} />
                        <View style={[css.row, css.text_center]}>
                            <Text style={[css.h6, css.fwBold]}>Total:</Text>
                            <Text style={[css.h6, css.fwBold, css.px_6]}>
                                {Intl.NumberFormat('es-MX', {
                                    style: 'currency',
                                    currency: 'MXN'
                                }).format(
                                    detalle.reduce((acc, item) => acc + (Number(item.declared_amount) || 0), 0)
                                )}
                            </Text>
                        </View>
                    </View>

                    <View style={[css.px_5, css.text_center, { marginTop: 10 }]}>
                        <View style={[]}>
                            <View style={[css.line, { marginVertical: 4 }]} />
                            <View style={[css.row, css.space_between]}>
                                <Text style={[css.h6, css.fwBold, css.px_5, css.py_5]}>    Cajero:</Text>
                            </View>
                        </View>
                        <View style={[{ marginTop: 30 }]}>
                            <View style={[css.line, { marginVertical: 4 }]} />
                            <View style={[css.row, css.space_between]}>
                                <Text style={[css.h6, css.fwBold, css.px_5, css.py_5]}>Encargado:</Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={[css.row, { marginTop: 8, marginBottom: 3 }]}>
                    <View style={css.px_4}>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Fondo:</Text>
                            <Text style={[css.h6, css.px_2]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(fondo)}</Text>
                            <Text style={[css.h6, css.px_2]}>G. Esperado:</Text>
                            <Text style={[css.h6, css.px_2]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(esperado)}</Text>
                            <Text style={[css.h6, css.px_2]}>G. Real:</Text>
                            <Text style={[css.h6, css.px_2]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(real)}</Text>
                            <Text style={[css.h6, css.px_2]}>Diferencia:</Text>
                            <Text style={[css.h6, css.px_2]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(difference)}</Text>
                        </View>
                    </View>
                </View>


                <Text style={[css.px_4, css.py_1, css.h6, css.fwBold, { marginTop: 5 }]}>Detalles </Text>

                <Text style={[css.px_4, css.py_1, css.h7, css.fwBold, { marginTop: 5 }]}>Descuentos.</Text>
                <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
                    <View style={css.table}>
                        {/* Encabezados */}
                        <View style={css.tableRowHeader}>
                            <Text style={[css.tableCellHeader]}>FOLIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_start]}>APLICADO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>REAL ($)</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>PORCENTAJE</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>COBRADO</Text>
                        </View>

                        {/* Filas */}
                        {descuentos.map((item, index) => (
                            <View key={index} style={css.tableRow}>
                                <Text style={css.tableCell}>{item.FOLIO}</Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_start]}>
                                    {item.descriptions}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.base)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.percentage)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.amount)}
                                </Text>
                            </View>
                        ))}
                        {/* Totalizador */}
                        <View style={[css.tableRow, { backgroundColor: '#f1f3f5' }]}>
                           
                          
                        </View>

                         <View style={[css.tableRow, { backgroundColor: '#f1f3f5' }]}>
                             <Text style={[css.tableCell, css.fw_bold, css.text_start]}>No impacta el registro de ingresos</Text>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Total</Text>
                         
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(descuentos.reduce((acc, item) => acc + parseFloat(item.base || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                             -
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(descuentos.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0))}
                            </Text>
                        </View>
                    </View>
                </View>



                <Text style={[css.px_4, css.py_1, css.h7, css.fwBold, { marginTop: 5 }]}>Ordenes de Servicio.</Text>
                <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
                    <View style={css.table}>
                        {/* Encabezados */}
                        <View style={css.tableRowHeader}>
                            <Text style={[css.tableCellHeader]}>FOLIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TRANS.</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>EFECTIVO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDD</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDC</Text>
                        </View>

                        {/* Filas */}
                        {ordenesFormatter.map((item, index) => (
                            <View key={index} style={css.tableRow}>
                                <Text style={css.tableCell}>{item.FOLIO}</Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TRANS)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.EFECTIVO)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDD)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDC)}
                                </Text>
                            </View>
                        ))}
                        {/* Totalizador */}
                        <View style={[css.tableRow, { backgroundColor: '#f1f3f5' }]}>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Total</Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ordenesFormatter.reduce((acc, item) => acc + parseFloat(item.TRANS || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ordenesFormatter.reduce((acc, item) => acc + parseFloat(item.EFECTIVO || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ordenesFormatter.reduce((acc, item) => acc + parseFloat(item.TDD || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ordenesFormatter.reduce((acc, item) => acc + parseFloat(item.TDC || 0), 0))}
                            </Text>
                        </View>
                    </View>
                </View>

                <Text style={[css.px_4, css.py_1, css.h7, css.fwBold, { marginTop: 5 }]}>Ventas. </Text>
                <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
                    <View style={css.table}>
                        {/* Encabezados */}
                        <View style={css.tableRowHeader}>
                            <Text style={[css.tableCellHeader]}>FOLIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TRANS.</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>EFECTIVO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDD</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDC</Text>
                        </View>

                        {/* Filas */}
                        {ventasFormatter.map((item, index) => (
                            <View key={index} style={css.tableRow}>
                                <Text style={css.tableCell}>{item.FOLIO}</Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TRANS)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.EFECTIVO)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDD)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDC)}
                                </Text>
                            </View>
                        ))}
                        {/* Totalizador */}
                        <View style={[css.tableRow, { backgroundColor: '#f1f3f5' }]}>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Total</Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ventasFormatter.reduce((acc, item) => acc + parseFloat(item.TRANS || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ventasFormatter.reduce((acc, item) => acc + parseFloat(item.EFECTIVO || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ventasFormatter.reduce((acc, item) => acc + parseFloat(item.TDD || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(ventasFormatter.reduce((acc, item) => acc + parseFloat(item.TDC || 0), 0))}
                            </Text>
                        </View>
                    </View>
                </View>

                <Text style={[css.px_4, css.py_1, css.h7, css.fwBold, { marginTop: 5 }]}>Anticipos. </Text>
                <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
                    <View style={css.table}>
                        {/* Encabezados */}
                        <View style={css.tableRowHeader}>
                            <Text style={[css.tableCellHeader]}>FOLIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TRANS.</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>EFECTIVO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDD</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>TDC</Text>
                        </View>

                        {/* Filas */}
                        {anticiposFormatter.map((item, index) => (
                            <View key={index} style={css.tableRow}>
                                <Text style={css.tableCell}>{item.FOLIO}</Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TRANS)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.EFECTIVO)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDD)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.TDC)}
                                </Text>
                            </View>
                        ))}
                        {/* Totalizador */}
                        <View style={[css.tableRow, { backgroundColor: '#f1f3f5' }]}>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Total</Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(anticiposFormatter.reduce((acc, item) => acc + parseFloat(item.TRANS || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(anticiposFormatter.reduce((acc, item) => acc + parseFloat(item.EFECTIVO || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(anticiposFormatter.reduce((acc, item) => acc + parseFloat(item.TDD || 0), 0))}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(anticiposFormatter.reduce((acc, item) => acc + parseFloat(item.TDC || 0), 0))}
                            </Text>
                        </View>
                    </View>
                </View>





            </Page>
        </Document>
    )
}
